import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, DetachedRouteHandle } from "@angular/router";

@Injectable({ providedIn: 'root' })
export class RouteCachingService {
  // A map to cached components, using the route component reusComponentId as the key and the component instance as the value.
  private _routesCache: Map<string, DetachedRouteHandle | any | null> = new Map();

  /**
   * Stores the component for the given route in the cache
   * @param route
   * @param detachedTree
   */
  public store(route: ActivatedRouteSnapshot, detachedTree: DetachedRouteHandle): void {
    const routeComponentKey = this.getRouteComponentKey(route);
    this._routesCache.set(routeComponentKey, detachedTree);
  }

  /**
   * 3. Retrieves the cached component for the given route.
   * @param route
   */
  public retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    const routeComponentKey = this.getRouteComponentKey(route);
    return this._routesCache.get(routeComponentKey) || null;
  }

  /**
   * Clear all cached components and destroy them
   */
  public clearCachedRoutes(): void {
    // deactivate dead components before removing from cache
    this._routesCache.forEach((value, key) => {
      if (value?.componentRef && value?.componentRef?.instance) {
        value?.componentRef.instance.ngOnDestroy();
      }
    });

    this._routesCache = new Map();
  }

  /**
   * Clear cached component by id set in the route config
   * @param reuseComponentId id set in the route for the reusable component
   */
  public clearCachedRoute(reuseComponentId: string): void {
    this._routesCache.forEach((value, key) => {
      if(key === reuseComponentId && value?.componentRef && value?.componentRef?.instance) {
        value?.componentRef.instance.ngOnDestroy();
      }
    });

    this._routesCache.delete(reuseComponentId);
  }

  /**
   * Get route key (to use it as key for saved route)
   * @param route
   * @returns
   */
  public getRouteComponentKey(route: ActivatedRouteSnapshot): string {
    let res = this.uuidv4();// Get a UUID as a first step in case reuseComponentId is missing in order to avoid having more than one _routesCache key with same value

    if (route.routeConfig && route.routeConfig.data && route.routeConfig.data["reuseComponentId"]) {
      res = route.routeConfig.data["reuseComponentId"];
    }

    return res;
  }

  /**
   * Generate UUID
   * @returns
   */
  private uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
      .replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0,
          v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
  }
}
